import { Info } from "lucide-react";
import RefundNote from "../../../../components/Notes/RefundNote";
const CheckoutFooterInfo = () => {
    return (
        <div className="root_track" style={{ display: "flex", gap: "9px", marginTop: "30px" }}>
            <div>
                <span>
                    <Info size={18} />
                </span>
            </div>
            <div>
                <RefundNote />
            </div>
        </div>
    );
};
export default CheckoutFooterInfo;
